import type { EntityRegistry, MigrateEntityResult } from './migrate';

import { migrateEntity } from './migrate';
import { isRecord } from './utils';

/**
 * `parsed` laid over `raw`: every value the schema produced wins, and whatever the schema does not
 * describe — the keys its parse dropped as unknown — is kept from `raw`. Arrays of equal length merge
 * item by item; otherwise the parsed array wins.
 */
export function overlayParsed(raw: unknown, parsed: unknown): unknown {
    if (Array.isArray(raw) && Array.isArray(parsed)) {
        return raw.length === parsed.length ? parsed.map((item, index) => overlayParsed(raw[index], item)) : parsed;
    }

    if (isRecord(raw) && isRecord(parsed)) {
        const result: Record<string, unknown> = { ...raw };

        Object.keys(parsed).forEach((key) => {
            result[key] = overlayParsed(raw[key], parsed[key]);
        });

        return result;
    }

    return parsed;
}

/**
 * Runs a legacy-only entity through its schema for the schema's normalisations (defaults, relocated
 * fields) without losing anything the schema does not describe — see {@link overlayParsed}.
 */
export function normalizeLegacyEntity<T>(entity: unknown, registry: EntityRegistry<T>): MigrateEntityResult<T> {
    const result = migrateEntity(entity, registry);

    return result.type === 'ok' ? { type: 'ok', value: overlayParsed(entity, result.value) as T } : result;
}
